<template>
  <div class="bq-infobox" :style="{ width: `${itemWidth}` }">
    <div class="bq-infobox-wrap" :class="classes">
      <div
        :style="{ backgroundImage: `url(${itemObj.iconUrl})` }"
        class="bq-advantage-icon"
        v-if="itemObj.iconUrl"
      ></div>
      <span v-else>{{ itemObj.index }}</span>
      <div class="bq-infobox-title">{{ itemObj.advTitles }}</div>
      <p class="bq-infobox-desc">{{ itemObj.advDesc }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'infobox',
  data() {
    return {};
  },
  computed: {
    itemWidth() {
      return (1 / this.col) * 100 + '%';
    },
  },
  props: {
    itemObj: {
      type: Object,
      default: () => {},
    },
    col: {
      type: Number,
      default: 1,
    },
    classes: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="less" scoped>
.bq-infobox {
  text-align: left;
  // width: 33.33%;

  &:hover {
    .bq-advantage-icon {
      transform: translate3d(0, -10px, 0);
    }
  }

  span {
    display: inline-block;
    text-align: center;
    color: #fff;
    width: 38px;
    height: 38px;
    line-height: 38px;
    background: rgba(12, 48, 145, 1);
    border-radius: 50%;
    margin-bottom: 20px;
  }

  .bq-advantage-icon {
    width: 40px;
    height: 40px;
    margin-bottom: 20px;
    transition: transform 0.3s ease-in;
    background-repeat: no-repeat;
    background-size: contain;
  }

  .bq-infobox-title {
    font-weight: 500;
    font-size: 20px;
    color: #333;
    margin-bottom: 10px;
  }
  .bq-infobox-desc {
    font-size: 16px;
    // width: 338px;
    margin: 0 auto;
  }
}
</style>
